
<template>
  <naj-modal
    ref="billTimelineModal"
    :title="''"
    button-size="small"
    :button-outlined="false"
    :width="1200"
    :persistent="true"
    :close-button="true"
    :content-loaded="billTimeline!=null"
    @onClose="$emit('billTimelineModalClose')"
  >
    <template slot-scope="{ }">
      <div :class="['modal-content']">
        <v-row class="d-flex justify-center">
          <v-col cols="10">
            <div class="mt-3">
              <div class="text-center text-h4 header-text  pb-10">
                {{ local.judicialFees.billTimeline }}
              </div>
              <v-timeline
                align-top
                :dense="$vuetify.breakpoint.smAndDown"
              >
                <v-timeline-item
                  v-for="(item, i) in billTimeline"
                  :key="i"
                  color="var(--app-light-secondary-color)"
                >
                  <v-card
                    outlined
                    class="card-boarder"
                  >
                    <v-card-title class="text-title">
                      {{ item.actionName }}
                    </v-card-title>
                    <v-card-text class="white">
                      <span color="#A6B8BB"> {{ formatGeorgianEnDateString(item.creationDate) }}</span>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapJudicialFeesActions } = createNamespacedHelpers('JudicialFeesModule');
import { formatGeorgianEnDateString, getTimePartArabic } from '@/helpers/utils';

export default {
  name: 'BillTimelineModal',
  components: {},
  props: {
    billObjectKey: {
      default: null,
      type: String,
      required: false,
    },
    modalVisibility: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      billTimeline: [],
    };
  },
  computed: {},
  watch: {
    modalVisibility(newVal) {
      newVal ? this.$refs.billTimelineModal.show() : this.$refs.billTimelineModal.close();
    },
    billObjectKey(newVal) {
      if (newVal) this.loadData();
    },
    onClose() {
      this.billTimeline = [];
    },
  },
  mounted() {
    if (this.billObjectKey) this.loadData();
  },
  methods: {
    formatGeorgianEnDateString,
    getTimePartArabic,
    ...mapJudicialFeesActions(['getBillTimeline']),
    loadData() {
      this.loading = true;
      this.getBillTimeline(this.billObjectKey)
        .then(({ data }) => {
          this.billTimeline = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

};
</script>

<style lang="scss" scoped>
    .header-text {
        color: var(--app-primary-color);
    }

.text-title {
  font: normal normal bold 20px/31px Almarai;
}

.card-boarder {
  border: 2px solid #dbdbdb;
}
</style>
